export default {
    install(Vue) {
        /**
         * 커스텀 모달을 표시하는 전역 메소드
         * @param {object} options - 모달 옵션
         * @param {'alert'|'confirm'} options.type - 모달 타입
         * @param {'error'|'warning'|'success'|'info'} options.state - 모달 상태
         * @param {string|VNode} options.title - 모달 제목 (문자열 또는 VNode)
         * @param {string|VNode} options.message - 모달 메시지 (문자열 또는 VNode)
         * @param {object} options.modalOptions - 추가적인 bvModal 옵션
         */
        Vue.prototype.$showModal = function({
                                                type = 'alert',
                                                state = 'info',
                                                title = '',
                                                message = '',
                                                modalOptions = {}
                                            }) {
            const h = this.$createElement;
            
            const defaultContent = {
                alert: {
                    error: { title: this.$t('오류'), message: this.$t('요청 처리 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.') },
                    warning: { title: this.$t('주의'), message: this.$t('처리 중 문제가 발생할 수 있으니 내용을 다시 확인해주세요.') },
                    success: { title: this.$t('성공'), message: this.$t('요청하신 작업이 성공적으로 처리되었습니다.') },
                    info: { title: this.$t('알림'), message: this.$t('전달된 정보를 확인해주세요.') },
                },
                confirm: {
                    error: { title: this.$t('삭제 확인'), message: this.$t('정말로 삭제하시겠습니까? 삭제된 데이터는 복구할 수 없습니다.') },
                    warning: { title: this.$t('경고'), message: this.$t('이 작업은 되돌릴 수 없습니다. 정말로 계속하시겠습니까?') },
                    success: { title: this.$t('완료 확인'), message: this.$t('이 작업을 완료 처리하시겠습니까?') },
                    info: { title: this.$t('정보 확인'), message: this.$t('입력하신 내용으로 계속 진행하시겠습니까?') },
                }
            }
            
            if(title === ''){
                title = defaultContent[type][state].title;
            }
            if(message === ''){
                message = defaultContent[type][state].message;
            }
            
            const config = {
                error:   { icon: 'exclamation-circle-fill', variant: 'danger',  okTitle: this.$t('확인'), cancelTitle: this.$t('취소') },
                warning: { icon: 'exclamation-triangle-fill', variant: 'warning', okTitle: this.$t('확인'), cancelTitle: this.$t('취소') },
                success: { icon: 'check-circle-fill',         variant: 'success', okTitle: this.$t('확인'), cancelTitle: this.$t('닫기') },
                info:    { icon: 'info-circle-fill',          variant: 'info',    okTitle: this.$t('확인'), cancelTitle: this.$t('닫기') }
            };
            const stateConfig = config[state] || config.info;
            
            const iconVNode = h('b-icon', {
                props: {
                    icon: stateConfig.icon,
                    fontScale: 2.2,
                    variant: stateConfig.variant
                },
                class: 'mr-3 flex-shrink-0',
            });
            
            const titleNode = typeof title === 'string'
                ? h('strong', { class: 'd-block mb-1 h5' }, title)
                : title;
            
            const messageNode = typeof message === 'string'
                ? h('p', { class: ['mb-0', 'text-secondary', 'fw-500'] }, message)
                : message;
            
            const messageVNode = h(
                'div',
                { class: 'd-flex align-items-start' }, 
                [
                    iconVNode,
                    h('div', { class: 'text-left w-100' }, [ titleNode, messageNode ])
                ]
            );
            
            const finalOptions = {
                title: '',
                okVariant: stateConfig.variant,
                okTitle: stateConfig.okTitle,
                cancelTitle: stateConfig.cancelTitle,
                centered: true,
                hideHeader: true,
                modalClass: 'custom-modal-shape',
                bodyClass: 'custom-modal-body',
                footerBgVariant: 'custom-modal-footer',
                ...modalOptions
            };
            
            if (type === 'confirm') {
                const confirmOptions = {
                    noCloseOnBackdrop: true,
                    noCloseOnEsc: true,     
                    ...finalOptions,
                };
                return this.$bvModal.msgBoxConfirm(messageVNode, confirmOptions);
            } else {
                finalOptions.cancelVariant = 'hide';
                return this.$bvModal.msgBoxOk(messageVNode, finalOptions);
            }
        };
    }
};
